/**
 * Click modes when clicking on an option with/without
 * a modifier key (ctrl, alt, cmd, shift)
 */

// no or multiple modifier keys
export const REPLACE_MODE = 'REPLACE_MODE'
// add/remove options from selection
export const ADD_MODE = 'ADD_MODE'
// create selection range
export const RANGE_MODE = 'RANGE_MODE'
